import { RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

const Edit = ( { className, attributes, setAttributes } ) => {
	const { content } = attributes;

	console.warn( 'edit', content );

	return (
		<div className="page__content-divider wp-block">
			<div className="page__content">
				<section className="page__content-subheadline.text">
					<hr></hr>
					<RichText
						tagName="h2"
						className={ className }
						value={ content }
						onChange={ ( content ) => setAttributes( { content } ) }
						placeholder={ __( 'Ueberschrift', 'ssvreutlingen' ) }
					/>
				</section>
			</div>
		</div>
	);
};

export default Edit;
